import { setErrorDialog, serverUrl, getheader } from "./CommonFunctions";

export function applyService(data, fn) {
  const _header = getheader()
  return dispatch => {

    dispatch({
      type: "LOADING",
      data: true
    })
    let serviceType = data.ServiceType;
    data = JSON.stringify(data)
    fetch(serverUrl + "ReceptionTasksApi/SaveService/", {
      body: data,
      headers: _header,
      method: 'POST',
      cache: "no-cache"
    })
      .then(res => res.json())
      .then(res => {

        dispatch({
          type: "LOADING",
          data: false
        })
        if (res.Message || isNaN(Number(res)) === true) {
          setErrorDialog(dispatch, res.Message ?? "", "ثبت سرویس");
          return;
        }
        setErrorDialog(dispatch, "success", "ثبت سرویس");
        fn(res, serviceType);
        return dispatch({
          type: "ADD_SERVICE",
          data: res
        })
      }
      ).catch(err => {
        console.error('[ADD_SERVICE]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
      });
  };
}
export function saveUsedProduct(data, fn) {
  const _header = getheader()
  return dispatch => {

    dispatch({
      type: "LOADING",
      data: true
    })
    data = JSON.stringify(data)
    fetch(serverUrl + "ProductRequestAPI/SaveUsedProduct/", {
      body: data,
      headers: _header,
      method: 'POST',
      cache: 'no-cache'
    })
      .then(res => res.json())
      .then(res => {

        dispatch({
          type: "LOADING",
          data: false
        });
        if (fn) {
          fn();
        }

        if (res === "Storage Is Not Valid") {
          setErrorDialog(dispatch, "برای این نماینده/تکنسین انباری تعریف نشده است", "ثبت قطعه مصرفی");
          return;
        }
        if (res === "NegativeCountInStorageNotAllowed") {
          setErrorDialog(dispatch, "موجودی کالا برای ثبت در قطعات سرویس کافی نیست", "ثبت قطعه مصرفی");
          return;
        }
        if (typeof res === "string" && res.includes("exception")) {
          setErrorDialog(dispatch, "اشکال در انجام عملیات", "ثبت قطعه مصرفی");
          return;
        }
        else if (typeof res === "number") {
          setErrorDialog(dispatch, "ثبت با موفقیت انجام شد", "ثبت قطعه مصرفی");
        }
      }
      ).catch(err => {
        console.error('[ADD_USED_PART]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
      });
  };
}
export function getserviceUsedParts(serviceID, serviceType) {
  //const _header = getHeaderGet();
  var token = localStorage.getItem('token')
  return dispatch => {

    dispatch({
      type: "LOADING",
      data: true
    })
    //var header = new Headers();
    fetch(serverUrl + "ProductRequestAPI/GetReducedProducts/?ServiceID=" + serviceID + '&ServiceType=' + serviceType, {
      headers: {
        "Token": token
      },
      method: 'GET',
      cache: 'no-cache'
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (res.Message && res.Message === "Error") {
          alert("اشکال در بازیابی قطعات مصرفی");
          return;
        }
        return dispatch({
          type: "GET_SERVICE_USEDPARTS",
          data: res
        })

      }).catch(err => {
        console.error('[err]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
        alert("اشکال در بازیابی قطعات مصرفی");
      });

  };
}
////////////////////////////////////////////////////////////////////
export function getTaskList(pagenumber, pageSize) {
  var token = localStorage.getItem('token')
  return dispatch => {

    dispatch({
      type: "LOADING",
      data: true
    })
    fetch(serverUrl + "ReceptionTasksApi/GetTasks/?pageSize=" + pageSize + '&PageNumber=' + pagenumber, {
      headers: {
        "Token": token
      },
      method: 'GET',
      cache: 'default'
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (res.Message) {
          if (res.Message === "Error") {
            alert("اشکال در بازیابی اطلاعات");

          }
          else if (res.Message === "UserIsNotRelatedToStaff") {
            alert("کاربر مورد نظر به تکنسین/پرسنل/نماینده ای متصل نیست");
          }
          res = null;
        }
        return dispatch({
          type: "GET_TASKS",
          data: res
        })

      }).catch(err => {
        console.error('[err]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
        alert("اشکال در بازیابی اطلاعات");
      });

  };
}
export function getMyTaskList(data, setTotalCount) {

  var token = localStorage.getItem('token')
  return dispatch => {

    dispatch({
      type: "GET_MY_TASKS",
      data: 'PENDING'
    })
    fetch(serverUrl + "ReceptionTasksApi/GetMyTasks", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: 'POST',
      cache: 'default'
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        });
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "جستجوی کارها")
          res = null;
        }
        if (setTotalCount) {
          if (res) {
            setTotalCount(res.TotalCount);
          }
          else {
            setTotalCount(0);
          }
        }
        return dispatch({
          type: "GET_MY_TASKS",
          data: res
        })

      }).catch(err => {
        console.error('[err]', err);
        return dispatch({
          type: "GET_MY_TASKS",
          data: null
        })
      });

  };
}
////////////////////////////////////////////////////////////////////////////////////
export function rejectService(serviceType, serviceID, rejectDesc, fn) {

  if (!rejectDesc || rejectDesc === "") {
    alert("ثبت دلیل رد الزامی است");
    return;
  }
  let token = localStorage.getItem("token");
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });
    fetch(serverUrl + "ReceptionTasksApi/RejectService", {
      headers: {
        'Token': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ ServiceID: serviceID, ServiceType: serviceType, RejectDesc: rejectDesc }),
      method: "POST",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        });
        if (res === "Success") {
          alert("عملیات با موفقیت انجام شد");
          fn();
        }
        else {
          alert("اشکال در انجام عملیات");
        }
      }).catch(e =>
        console.log("[RejectService]", e))
  }
}
////////////////////////////////////////////////////////////////////
export function getService(serviceType, serviceID) {
  let token = localStorage.getItem('token');
  return dispatch => {

    if (serviceID === -1) {
      return dispatch({
        type: "GET_SERVICE",
        data: null
      })
    }
    dispatch({
      type: "GET_SERVICE",
      data: "Pending"
    })
    fetch(serverUrl + "ReceptionTasksApi/GetService?ServiceType=" + serviceType + "&&ServiceID=" + serviceID, {
      headers: {
        "token": token
      },
      method: 'GET',
      cache: 'no-cache'
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (res.Message && res.Message === "Error") {
          setErrorDialog(dispatch, "اشکال در بازیابی اطلاعات پذیرش", "دریافت اطلاعات پذیرش");
          res = null;
        }
        return dispatch({
          type: "GET_SERVICE",
          data: res
        })

      }).catch(err => {
        console.error('[err]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
        alert("اشکال در بازیابی اطلاعات");
      });
  }

};
////////////////////////////////////////////////////////////////////
export function getServiceReceipt(serviceType, serviceID) {
  return dispatch => {
    dispatch({
      type: "GET_SERVICE_RECEIPT",
      data: "PENDING"
    });
    fetch(serverUrl + `ReceptionTasksApi/GetServiceReceipt?serviceID=${serviceID}&serviceType=${serviceType}`, {
      headers: getheader(),
      method: 'GET',
      cache: 'no-cache'
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "رسید تکنسین");
          res = null;
        }
        return dispatch({
          type: "GET_SERVICE_RECEIPT",
          data: res
        })

      }).catch(err => {
        console.error('[GET_SERVICE_RECEIPT]', err);
        setErrorDialog(dispatch, "اشکال در بازیابی رسید تکنسین", "رسید تکنسین");
      });
  }

};
export function getServiceInvoice(serviceType, serviceID) {
  return dispatch => {
    dispatch({
      type: "GET_SERVICE_INVOICE",
      data: "PENDING"
    });
    fetch(serverUrl + "ReceptionTasksApi/GetServiceInvoice?serviceID=" + serviceID + "&serviceType=" + serviceType, {
      method: 'GET',
      cache: 'no-cache',
      headers: getheader()
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "فاکتور خدمات");
          res = null;
        }

        return dispatch({
          type: "GET_SERVICE_INVOICE",
          data: res
        })

      }).catch(err => {
        console.error('[GET_SERVICE_INVOICE]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
        alert("اشکال در بازیابی اطلاعات");
      });
  }

};
export function getServiceTotalCost(serviceType, serviceID) {
  return dispatch => {
    dispatch({
      type: "GET_SERVICE_TOTALCOST",
      data: "PENDING"
    });
    fetch(serverUrl + `ReceptionTasksApi/GetServiceTotalCost?serviceID=${serviceID}&serviceType=${serviceType}`, {
      method: 'GET',
      cache: 'no-cache',
      headers: getheader()
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          res = null;
          setErrorDialog(dispatch, res.Message, "فاکتور خدمات");
        }

        return dispatch({
          type: "GET_SERVICE_TOTALCOST",
          data: res
        })

      }).catch(err => {
        console.error('[GET_SERVICE_TOTALCOST]', err);
      });
  }

};
export function saveServiceInvoice(serviceType, serviceID, onSuccess) {
  return dispatch => {
    if (!serviceID || !serviceType) {
      return dispatch({
        type: "SAVE_SERVICE_INVOICE",
        data: "ServiceID_IS_UNDEFINED"
      });
    }
    dispatch({
      type: "SAVE_SERVICE_INVOICE",
      data: "PENDING"
    });
    fetch(serverUrl + `ReceptionTasksApi/SaveServiceInvoice/${serviceType}/${serviceID}`, {
      headers: {
        "Token": localStorage.getItem("token"),
        "Content-Type": "application/json"
      },
      // body:{ serviceID: serviceID },
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        if (!res.status && res.Message === "Error") {
          alert("اشکال در ارتباط با سرور");
          return dispatch({
            type: "SAVE_SERVICE_INVOICE",
            data: "CONNECTION_ERROR"
          });
        }
        if (res.status === 400) {
          alert("اشکال در انجام عملیات");
          return dispatch({
            type: "SAVE_SERVICE_INVOICE",
            data: "Error"
          })
        }
        else {
          alert("عملیات با موفقیت انجام شد");
          return dispatch({
            type: "SAVE_SERVICE_INVOICE",
            data: "Success"
          });
        }
      }).catch(e => {
        console.log("[SAVE_SERVICE_INVOICE]", e);
      })
  }
}
////////////////////////////////////////////////////////////////////
export function deleteService(serviceType, serviceID, fn) {
  let token = localStorage.getItem('token');
  return dispatch => {
    if (serviceType === null || serviceType === '' || serviceType === undefined || serviceID === '' || serviceID === undefined || serviceID === null) {
      return dispatch({
        type: "DELETE_SERVICE",
        data: "NotFound"
      })
    }
    fetch(serverUrl + "ReceptionTasksApi/DeleteService?serviceType=" + serviceType + "&&serviceID=" + serviceID, {
      headers: {
        "token": token
      },
      method: 'GET',
      cache: 'no-cache'
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (res.Message && res.Message === "Error") {
          alert("اشکال در انجام اطلاعات");
          return;
        }
        else {
          alert("عملیات با موفقیت انجام شد");
          if (fn) {
            fn();
          }
        }


      }).catch(err => {
        console.error('[DELETE_SERVICE]', err);
        dispatch({
          type: "LOADING",
          data: false
        });
        alert("اشکال در انجام اطلاعات");
      });
  }

};
export function deleteServiceUsedPart(id, fn) {
  return dispatch => {
    dispatch({
      type: "Loading",
      data: true
    });
    let token = localStorage.getItem('token');
    fetch(serverUrl + "ProductRequestAPI/DeleteProductRequestByID?ID=" + id, {
      headers: {
        'Token': token
      },
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        });
        if (res === "true") {
          alert("حذف با موفقیت انجام شد");
          if (fn) {
            fn();
          }
        }
        else {
          alert("اشکال در انجام عملیات");
        }
      }).catch(err => {
        console.log("[DELETE USEDPART]", err);
        dispatch({
          type: "LOADING",
          data: false
        });
      })
  }
}
export function attachFile(fileInput, parentID, attachmentType, fn, moreInfo) {
  var formdata = new FormData();
  for (let i = 0; i < fileInput.files.length; i++) {
    formdata.append(fileInput.files[i].name, fileInput.files[i]);
    formdata.append("ParentID", parentID);
    formdata.append("AttachmentType", attachmentType);
  }
  if (moreInfo) {
    formdata.append("moreInfo", moreInfo);
  }
  var xhr = new XMLHttpRequest();
  xhr.open('POST', serverUrl + 'api/Attachments/Upload', true);
  xhr.setRequestHeader("token", localStorage.getItem("token"));
  xhr.setRequestHeader("NameIsUniq", true);
  xhr.send(formdata);
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      var response = JSON.parse(xhr.responseText);
      if (response.Message !== "Error") {
        alert("بارگذاری با موفقیت انجام شد");
        if (fn)
          fn();
      }
      else {
        alert("اشکال در آپلود فایل");
      }

    }
    return "UnExpected Error";

  };
}
export function attachSignature(parentID, parentType, signatureData, fn) {
  var formdata = new FormData();
  formdata.append("Signature_" + parentType + parentID + ".png", signatureData);
  formdata.append("ParentID", parentID);
  formdata.append("AttachmentType", parentType);
  formdata.append("IsForSignature", "true");
  var xhr = new XMLHttpRequest();
  xhr.open('POST', serverUrl + 'api/Attachments/Upload', true);
  xhr.setRequestHeader("NameIsUniq", true);
  xhr.send(formdata);
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      var response = JSON.parse(xhr.responseText);
      if (response.Message !== "Error") {
        alert("ثبت با موفقیت انجام شد");
        if (fn)
          fn();
      }
      else {
        alert("اشکال در ثبت امضا");
      }

    }
    return "UnExpected Error";

  };
}
export function getServiceAttachments(serviceType, serviceID) {
  return dispatch => {
    dispatch({
      type: "GET_SERVICE_ATTACHMENTS",
      data: 'PENDING'
    });
    fetch(serverUrl + `api/Attachments/GetAttachmentList?parentID=${serviceID}&attachmentType=${serviceType}`, {
      redirect: "follow",
      headers: {
        'Content-Type': 'application/json',
        "Data-Type": "JSON"
      },
      method: 'GET',
      cache: 'no-cache'
    }).then(res => res.json())
      .then(res => {

        if (!res) {
          return dispatch({
            type: "GET_SERVICE_ATTACHMENTS",
            data: null
          })
        }
        if (res.Message && res.Message === "Error") {
          alert("اشکال در بازیابی پیوست ها");
          return;
        }
        return dispatch({
          type: "GET_SERVICE_ATTACHMENTS",
          data: res
        })

      }).catch(err => {
        console.error('[GET_SERVICE_ATTACHMENTS]', err);
        dispatch({
          type: "GET_SERVICE_ATTACHMENTS",
          data: null
        });
      });
  }

};
export function downloadFile(itemID, attachmentType) {
  // window.open(serverUrl + `api/Attachments/DownloadAttachment?id=${itemID}&attachmentType=${attachmentType}`, "download");
  fetch(serverUrl + `api/Attachments/DownloadAttachment?id=${itemID}&attachmentType=${attachmentType}`,
    {
      headers: {
        'Content-Type': 'blob',
        'token': localStorage.getItem("token")
      }
      , method: "get"
    })
    .then((response) => {
      response.blob()
        .then((blob) => {
          if (blob.type === "application/json") {
            return;
          }
          var a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.download = "Download";
          a.click();
        })
    })
}
export function setRejectServicePopup(status) {
  return dispatch => {
    return dispatch({
      type: "SET_REJECTSERVICE_POPUP",
      data: status
    });
  }
}
export function deleteAttachment(id, type, onSuccess) {
  return dispatch => {
    dispatch({
      type: "DELETE_ATTACHMENT",
      data: "PENDING"
    });
    fetch(serverUrl + `api/Attachments/DeleteAttachment?id=${id}&attachmentType=${type}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res === "Success") {
          alert("حذف پیوست با موفقیت انجام شد");
          if (onSuccess) {
            onSuccess();
          }
        }
        else {
          alert("اشکال در انجام عملیات حذف");
          return dispatch({
            type: "DELETE_ATTACHMENT",
            data: "ERROR"
          });
        }
      }).catch(e => {
        console.log("[DELETE_ATTACHMENT]", e);
        return dispatch({
          type: "DELETE_ATTACHMENT",
          data: "ERROR"
        });
      })
  }
}
export function setReferServicePopup(status) {
  return dispatch => {
    return dispatch({
      type: "SET_REFERSERVICE_POPUP",
      data: status
    });
  }
}
export function setSelectStaffPopup(status) {
  return dispatch => {
    return dispatch({
      type: "SET_SELECTSTAFF_POPUP",
      data: status
    });
  }
}
export function setSerialHistoryPopup(status) {
  return dispatch => {
    return dispatch({
      type: "SET_SERIALHISTORY_POPUP",
      data: status
    });
  }
}
export function getRelatedStaffsToAgent(data) {
  if (!data) {
    data = {};
  }
  return dispatch => {
    dispatch({
      type: "GET_RELATEDSTAFFS",
      data: "PENDING"
    });
    fetch(serverUrl + "api/StaffAPI/GetRelatedStaffsToAgent", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: "POST",
      cache: "no-cache"

    }).then(res => res.json())
      .then(res => {
        if (res.Message === "Error") {
          res = null;
        }
        dispatch({
          type: "GET_RELATEDSTAFFS",
          data: res
        })
      }).catch(err => {
        dispatch({
          type: "GET_RELATEDSTAFFS",
          data: null
        });
        console.log("[GetRelatedStaffsForAgent]", err)
      })
  }
}
export function getAgentList(data) {
  if (!data) {
    data = {};
  }
  return dispatch => {
    dispatch({
      type: "GET_AGENT_LIST",
      data: "PENDING"
    });
    fetch(serverUrl + "api/StaffAPI/GetAgentList", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: "POST",
      cache: "no-cache"

    }).then(res => res.json())
      .then(res => {
        if (res.Message === "Error") {
          res = null;
        }
        dispatch({
          type: "GET_AGENT_LIST",
          data: res
        })
      }).catch(err => {
        dispatch({
          type: "GET_AGENT_LIST",
          data: null
        });
        console.log("[GET_AGENCT_LIST]", err)
      })
  }
}
export function getServiceCountReport() {
  let token = localStorage.getItem("token");
  let sUrl = localStorage.getItem("ServerUrl");
  if (!token || !sUrl) {
    return dispatch => {
      return dispatch({
        type: "GET_SERVICE_COUNT",
        data: []
      });
    }
  }
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });
    fetch(sUrl + "api/ServiceReportsAPI/GetServiceCountReport?agencyID=null&&staffID=0", {
      headers: {
        'Token': token
      },
      method: "GET",
      cache: "default"
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        });
        return dispatch({
          type: "GET_SERVICE_COUNT",
          data: res
        });

      }
      ).catch(error => console.log("GETServiceCountReport", error))
  }
}
export function getServiceDeadlineReport() {
  let token = localStorage.getItem("token");
  let sUrl = localStorage.getItem("ServerUrl");
  if (!token || !sUrl) {
    return dispatch => {
      return dispatch({
        type: "SERVICE_DEADLINE",
        data: ""
      });
    }
  }
  return dispatch => {
    dispatch({
      type: "SERVICE_DEADLINE",
      data: "pending"
    });
    fetch(sUrl + "api/ServiceReportsAPI/GetServiceDeadlineReport?staffID=0&agencyID=null", {
      headers: {
        'Token': token
      },
      method: "GET",
      cache: "default"
    }).then(res => res.json())
      .then(res => {
        if (res.status === 400) {
          alert("اشکال در انجام عملیات");
          dispatch({
            type: "SERVICE_DEADLINE_REPORT",
            data: []
          });
        }
        else {
          dispatch({
            type: "SERVICE_DEADLINE_REPORT",
            data: res
          });
        }
      }
      ).catch(er => {
        console.log("[SERVICE_DEADLINE_REPORT]", er);
        dispatch({
          type: "SERVICE_DEADLINE_REPORT",
          data: []
        });
      });
  }
}
export function getStaffTotalFunctions() {
  let token = localStorage.getItem("token");
  let sUrl = localStorage.getItem("ServerUrl");
  if (!token || !sUrl) {
    return dispatch => {
      dispatch({
        type: "STAFF_TOTAL_FUNCTION",
        data: ""
      });
    }
  }
  return dispatch => {
    dispatch({
      type: "STAFF_TOTAL_FUNCTION",
      data: "pending"
    });
    fetch(sUrl + "api/ServiceReportsAPI/GetStaffTotalFunctions?staffID=0&agencyID=null", {
      headers: {
        'Token': localStorage.getItem("token")
      },
      method: "GET",
      cache: "default"
    }).then(res => res.json())
      .then(res => {
        if (res.status === 400) {
          alert("اشکال در انجام عملیات");
          dispatch({
            type: "STAFF_TOTAL_FUNCTION",
            data: []
          });
        }
        else {
          dispatch({
            type: "STAFF_TOTAL_FUNCTION",
            data: res
          });
        }
      }
      ).catch(er => {
        console.log("[STAFF_TOTAL_FUNCTION]", er);
        dispatch({
          type: "STAFF_TOTAL_FUNCTION",
          data: []
        });
      });
  }
}
export function getStaffReportList() {
  return dispatch => {
    fetch(serverUrl + "StaffReportBySMSAPI/StaffReportBySMSServiceSelectAll", {
      method: "GET",
      cache: "default"
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "GET_STAFF_REPORT",
          data: res
        })
      })
  }
}
export function getSerialHistory(serial, cardNo, customerCode, productCode) {

  return dispatch => {
    if (!serial && !cardNo && !customerCode && !productCode) {
      alert("هیچکدام از فیلدهای جستجو پر نشده است");
      return dispatch({
        type: "GET_SERIAL_HISTORY",
        data: []
      });
    }
    dispatch({
      type: "GET_SERIAL_HISTORY",
      data: "PENDING"
    });
    fetch(serverUrl + `api/GuarantyAPI/GetSerialHistory?serial=${serial ?? -1}&cardNo=${cardNo ?? -1}&customerCode=${customerCode ?? -1}&productCode=${productCode ?? -1}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (!res || res.status === "404" || res.status === "400") {
          alert("اشکال در انجام عملیات");
          dispatch({
            type: "GET_SERIAL_HISTORY",
            data: []
          });
          return;
        }
        if (res && !res.status && res === "Error") {
          alert("اشکال در ارتباط با سرور");
          dispatch({
            type: "GET_SERIAL_HISTORY",
            data: []
          });
          return;
        }
        dispatch({
          type: "GET_SERIAL_HISTORY",
          data: res
        })
      }

      ).catch(e => {
        dispatch({
          type: "GET_SERIAL_HISTORY",
          data: "PENDING"
        });
        console.log("[GET_SERIAL_HISTORY]", e)
      });
  }
}
export function sendServiceInvoiceSMS(serviceType, serviceID, mobile) {
  if (!mobile || mobile.length < 10) {
    alert("موبایل مشتری معتبر نیست");
    return;
  }
  fetch(serverUrl + `ReceptionTasksApi/SendServiceInvoiceSMS?serviceType=${serviceType}&serviceID=${serviceID}&mobile=${mobile}`, {
    headers: getheader(),
    method: "GET",
    cache: "no-cache"
  }).then(res => res.json())
    .then(res => { alert("پیامک یا موفقیت ارسال شد"); })
    .catch(e => {
      console.log("SendInvoiceSMS:", e);
      alert("اشکال در ارسال پیامک")
    })
}
export function addNewRepairBug(repairID, bugId, onSuccess) {
  fetch(serverUrl + `ReceptionTasksApi/AddNewRepairBug?repairID=${repairID}&bugId=${bugId}`, {
    headers: getheader(),
    method: "GET",
    cache: "no-cache"
  }).then(res => res.json())
    .then(res => {
      if (res.Message) {
        alert("اشکال در انجام عملیات");
        return;
      }
      if (res === "Success") {
        alert("عملیات با موفقیت انجام شد");
        if (onSuccess) {
          onSuccess();
        }
      }
    }).catch(e => {
      alert("اشکال در انجام عملیات");
      console.log("[ADD_New_BUG]", e);
    })
}
export function getRepairBugList(repairID) {
  return dispatch => {
    dispatch({
      type: "GET_REPAIR_BUGS",
      data: "PENDING"
    });
    fetch(serverUrl + `ReceptionTasksApi/GetRepairBugList?repairID=${repairID}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res === "Error" || res.Message) {
          setErrorDialog(dispatch, res?.Message ?? res, "فهرست ایراد");
          res = null;
        }
        return dispatch({
          type: "GET_REPAIR_BUGS",
          data: res
        });

      }).catch(e => {
        console.log("[error]", e?.message);
        return dispatch({
          type: "GET_REPAIR_BUGS",
          data: null
        });
      })
  }
}
export function deleteRepairBug(bugId, onSuccess) {
  return dispatch => {
    fetch(serverUrl + `ReceptionTasksApi/DeleteRepairBug?Id=${bugId}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          alert("اشکال در انجام عملیات");
          return;
        }
        if (res === "Success") {
          alert("عملیات با موفقیت انجام شد");
          if (onSuccess) {
            onSuccess();
          }
        }
      }).catch(e => {
        alert("اشکال در انجام عملیات");
        console.log("[ADD_New_BUG]", e);
      })
  }
}
export function setCustomerFaultsPop(status) {
  return dispatch =>
    dispatch({
      type: "SET_CUSTOMER_FAULTS",
      data: status
    })
}
export function loadFaultsByCustomer(name) {
  return dispatch => {
    dispatch({
      type: "LOAD_FAULTS_CUSTOMER",
      data: "PENDING"
    });
    fetch(serverUrl + `ReceptionTasksApi/LoadFaultsByCustomer?name=${name}`, {
      headers: getheader(),
      method: "GET",
      cache: "default"
    }).then(res => res.json())
      .then(res => {
        if (res === "Error" || res.Message) {
          alert("اشکال در بازیابی اطلاعات");
          res = null
        }
        dispatch({
          type: "LOAD_FAULTS_CUSTOMER",
          data: res
        })
      }).catch(e =>
        dispatch({
          type: "LOAD_FAULTS_CUSTOMER",
          data: null
        })
      )
  }
}
export function getServiceStatusList() {
  return dispatch => {
    dispatch({
      type: "GET_SERVICE_STATUS",
      data: "PENDING"
    });
    fetch(serverUrl + "ReceptionTasksApi/GetServiceStatusList", {
      headers: getheader(),
      method: "GET",
      cache: "default"
    }).then(res => res.json()).then(res => {
      if (res === "Error" || res.Message) {
        res = null;
      }
      dispatch({
        type: "GET_SERVICE_STATUS",
        data: res
      });
    }).catch(e => {
      console.log("[GET_SERVICE_STATUS]", e);
      dispatch({
        type: "GET_SERVICE_STATUS",
        data: null
      });
    })
  }
}
export function setSignaturePop(status) {
  return dispatch => {
    dispatch({
      type: "SIGNATURE_POP",
      data: status
    });
  }
}
export function archiveService(serviceType, serviceID, fn) {
  return dispatch => {
    dispatch({
      type: "ARCHIVE_SERVICE",
      data: "PENDING"
    });
    fetch(serverUrl + `ReceptionTasksAPI/ArchiveService?serviceType=${serviceType}&serviceID=${serviceID}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        dispatch({
          type: "ARCHIVE_SERVICE",
          data: "DONE"
        });
        if (res.Message) {
          setErrorDialog(dispatch, res.Message ?? "", "ثبت سرویس");
          return;
        }
        setErrorDialog(dispatch, "success", "ثبت سرویس");
        fn();
      }).catch(err => {
        dispatch({
          type: "ARCHIVE_SERVICE",
          data: "DONE"
        });
        console.log("[ARCHIVE_SERVICE]", err);
      })
  }
}